import { LocalLoadable } from '@g2-shared/components';
import { lazy } from 'react';

export const UserDetailsPage = LocalLoadable(lazy(() => import('../pages/details')));

export const UserPersonalDetailsPage = LocalLoadable(
  lazy(() => import('../pages/personal-details'))
);

export const UserRegisterPage = LocalLoadable(lazy(() => import('../pages/register')));

export const UserCompletedRegisterPage = LocalLoadable(
  lazy(() => import('../pages/register-completed'))
);
